import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/Button';
const galleryItems = [{
  id: 1,
  title: 'Cornrow Design with Red Accents',
  image: 'https://cdn.magicpatterns.com/uploads/2Qfc3KmQoWNcVTvmVYYkdo/Screenshot_2026-03-09-16-45-42-463_com.instagram.android~2.jpg'
}, {
  id: 2,
  title: 'Braided Bun Updo',
  image: 'https://cdn.magicpatterns.com/uploads/mduzSAbnSFxDsNiBM9LbEV/Screenshot_2026-03-09-16-46-02-289_com.instagram.android~2.jpg'
}, {
  id: 3,
  title: 'Golden Highlight Braids',
  image: 'https://cdn.magicpatterns.com/uploads/ntuXXk6dhgSocK65vwexHn/Screenshot_2026-03-09-16-46-08-668_com.instagram.android.jpg'
}, {
  id: 4,
  title: 'Stitch Cornrow Braids',
  image: 'https://cdn.magicpatterns.com/uploads/2Y3z2g48Gc8k22BWZeZvcT/Screenshot_2026-03-09-16-45-31-768_com.instagram.android.jpg'
}, {
  id: 5,
  title: 'Senegalese Twists Ponytail',
  image: 'https://cdn.magicpatterns.com/uploads/5i4NjCL7or41TwX4qMNqKB/Screenshot_2026-03-09-16-46-14-281_com.instagram.android.jpg'
}, {
  id: 6,
  title: 'Feed-In Cornrows',
  image: 'https://cdn.magicpatterns.com/uploads/iM47KbB5Jo42SFFwZS7tRm/Screenshot_2026-03-09-16-46-18-821_com.instagram.android.jpg'
}, {
  id: 7,
  title: 'Box Braids with Curly Ends',
  image: 'https://cdn.magicpatterns.com/uploads/v3FcvGYerKPutcLmZh6e88/Screenshot_2026-03-09-16-46-23-795_com.instagram.android.jpg'
}, {
  id: 8,
  title: 'Goddess Braids',
  image: 'https://cdn.magicpatterns.com/uploads/j2hwEXJfU1vkYMivjDSZ8f/pexels-_brunovisual-1157201511-32426330.jpg'
}, {
  id: 9,
  title: 'Classic Cornrow Braids',
  image: 'https://cdn.magicpatterns.com/uploads/2ExGGdDti1RWcm2ZrzRPZx/image.png'
}, {
  id: 10,
  title: 'Box Braids',
  image: 'https://cdn.magicpatterns.com/uploads/24xpJUqyuniAcrzYKaT1RK/image.png'
}, {
  id: 11,
  title: 'Stitch Braids Close-Up',
  image: 'https://cdn.magicpatterns.com/uploads/mPkqr8gBVMCxFyUdRqAjKf/image.png'
}, {
  id: 12,
  title: 'Happy Client',
  image: 'https://cdn.magicpatterns.com/uploads/8gRTukumFLLYVy5Zhg6neZ/image.png'
}];
export { galleryItems };
interface GallerySectionProps {
  showAll?: boolean;
}
export function GallerySection({
  showAll = false
}: GallerySectionProps) {
  const navigate = useNavigate();
  const displayItems = showAll ? galleryItems : galleryItems.slice(0, 6);
  return <section id="gallery" className="py-8 md:py-24 bg-cream" data-id="element-169">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        {!showAll && <div className="flex flex-col md:flex-row md:items-end justify-between mb-12" data-id="element-171">
            <div className="max-w-2xl" data-id="element-172">
              <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl font-heading font-bold text-jet mb-4" data-id="element-173">
                Our Portfolio
              </motion.h2>
              <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-jet/60 text-lg" data-id="element-174">
                A glimpse into the artistry and precision of our master
                braiders.
              </motion.p>
            </div>
            <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="mt-6 md:mt-0" data-id="element-175">
              <a href="https://www.instagram.com/benishairbraiding/" target="_blank" rel="noopener noreferrer" className="text-burgundy font-medium hover:text-jet transition-colors flex items-center gap-2" data-id="element-176">
                Follow us on Instagram →
              </a>
            </motion.div>
          </div>}

        {/* Grid: 1 col mobile, 2 col tablet, 3 col desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-177">
          {displayItems.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="relative w-full aspect-[4/5] rounded-sm overflow-hidden group cursor-pointer" data-id="element-178">
              <img src={item.image} alt={item.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-179" />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-jet/80 via-jet/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" data-id="element-180"></div>

              {/* Content */}
              <div className="absolute inset-0 p-6 flex flex-col justify-end translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-181">
                <div className="w-8 h-1 bg-golden mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100" data-id="element-182"></div>
                <h3 className="text-xl font-heading font-bold text-cream opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200" data-id="element-183">
                  {item.title}
                </h3>
              </div>
            </motion.div>)}
        </div>

        {/* View All Button - only on homepage */}
        {!showAll && <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 flex justify-center" data-id="element-184">
            <Button variant="outline" size="lg" onClick={() => navigate('/gallery')} data-id="element-185">
              View All Gallery
            </Button>
          </motion.div>}
      </div>
    </section>;
}